<div class="content-wrap">
    <div class="slot-success">
      <img src="shared-assets/images/success-connct.svg" alt="" />
      <h2>Response has been submitted successfully!</h2>
    </div>
</div>
  